<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%', background: '#fff' }">
    <el-row class="mb-10px float-right">
      <el-button @click="back">{{ $t('back') }}</el-button>
    </el-row>
    <el-table :data="tableData" border stripe v-loading="loading" style="height: calc(100% - 96px)">
      <el-table-column
        :label="$t('整改时间')"
        align="center"
        prop="reorganizeTime"
      ></el-table-column>
      <el-table-column
        :label="$t('整改项')"
        align="center"
        prop="classAttributeName"
      ></el-table-column>
      <el-table-column :label="$t('第几行')" align="center" prop="rowNo"></el-table-column>
      <el-table-column :label="$t('整改前')" align="center" prop="beforeValue"></el-table-column>
      <el-table-column :label="$t('整改后')" align="center" prop="afterValue"></el-table-column>
      <el-table-column
        :label="$t('异常描述')"
        align="center"
        prop="exceptionDes"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        :label="$t('整改人')"
        align="center"
        prop="createdUserName"
      ></el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px r"
      background
      @current-change="getTableData"
      @size-change="searchData"
      :current-page.sync="pageNo"
      :page-size.sync="pageSize"
      :page-sizes="[10, 20, 30, 50]"
      layout="->, total, sizes, prev, pager, next"
      :total="total"
    ></el-pagination>
  </el-card>
</template>

<script>
import StandardManagementService from '@/services/thApi/StdClassDataBatch'

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      pageNo: 1,
      pageSize: 20,
      total: 0,
    }
  },
  computed: {
    id() {
      return this.$route.query.id || null
    },
    classId() {
      return this.$route.query.classId || null
    },
  },
  methods: {
    async getTableData() {
      const params = {
        taskRunRecordId: this.id,
        pageIndex: this.pageNo,
        pageSize: this.pageSize,
        classId: this.classId,
      }
      this.loading = true
      const res = await StandardManagementService.getRRecords(params)
      this.loading = false
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.tableData = res.data
        this.total = res.totalCount
      }
    },
    searchData() {
      this.pageNo = 1
      this.getTableData()
    },
    back() {
      this.$router.go(-1)
    },
  },
  created() {
    this.getTableData()
  },
}
</script>

<style lang="scss" scoped>

</style>
